import { ViewMetadata } from '../../View'

const FallbackView: ViewMetadata<null> = {
  name: 'Unknown view',
  id: 'fallback',
}

export default FallbackView
